import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import isArray from 'lodash/isArray'
import { getUnique } from 'Services/axiosService'
import { ApiServiceType, ApiResult, ApiCategory, ApiGroup, ApiAllCategories } from 'Types'

const endpoint = `${apiUrl.stable}/categoria`

export const getCategoriesByPrefix = (prefix: string): ApiResult<ApiCategory[]> => {
  const url = `${endpoint}/prefixo`
  const params = { prefix }

  return getUnique(url, { params }, 'categoryPrefix')
}

export const getServiceTypeByPrefix = (prefix: string): ApiResult<ApiServiceType[]> => {
  const url = `${endpoint}/especialidade/prefixo`
  const params = { prefix }

  return getUnique(url, { params }, 'serviceTypePrefix')
}

export const getGroupList = (): ApiResult<ApiGroup> => {
  const url = `${endpoint}/grupo`

  const headers = { ...jsonWebToken.header }

  return axios.get(url, { headers })
}

export const getCategoryList = (idList: string & string[]): ApiResult<ApiCategory[]> => {
  const url = `${endpoint}/ids`

  const headers = { ...jsonWebToken.header }

  const ids = isArray(idList)
    ? idList.join(',')
    : idList

  const params = { ids }

  return axios.get(url, { headers, params })
}

export const getServiceIdInfo = (id: number): ApiResult<ApiServiceType> => {
  const url = `${endpoint}/especialidade`

  const params = { id }

  return axios.get(url, { params })
}

export const getCategorySlugInfo = (slug: string): ApiResult<ApiServiceType> => {
  const url = `${endpoint}/slug`

  const params = { slug }

  return axios.get(url, { params })
}

export const getServiceSlugInfo = (serviceType: string) => {
  const url = `${endpoint}/especialidade/slug`

  const params = { slug: serviceType }

  return axios.get(url, { params })
}

export const getAllCategoriesAndServices = ():ApiResult<ApiAllCategories[]> => {
  const url = `${endpoint}/list-all`

  return axios.get(url)
}

export default {
  getCategoriesByPrefix,
  getGroupList,
  getCategoryList,
  getServiceIdInfo,
  getCategorySlugInfo,
  getServiceSlugInfo,
}